const isTouchDevice = function () {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0))
}

const isIphone = function () {
  return navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i)
}

const desktopMedia = window.matchMedia('(min-width: 1200px)')

export {
  isTouchDevice,
  isIphone,
  desktopMedia
}
